import { Component, Input } from '@angular/core';

/**
 * Reusable component for hexagon with image.
 */
@Component({
    selector: 'isophi-hexagon',
    templateUrl: './hexagon.component.html',
    styleUrls: ['./hexagon.component.css'],
    standalone: false
})
export class HexagonComponent {
  @Input() public iconUrl = '';
}
